import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HeaderDealOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/header-deal/header-deal-wrapper.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  selector: 'app-header-deal-mobile',
  templateUrl: './header-deal-mobile.component.html',
  styleUrls: ['./header-deal-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderDealMobileComponent extends HeaderDealOpenQuoteWrapper {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
